<div class="bg-primary-700 max-w-100 [transform:translateZ(0)] overflow-hidden rounded-2xl p-4">
  <section
    class="flex w-full shrink-0 flex-col items-center gap-4 rounded-2xl p-4"
    [style.background]="background()">
    <image
      class="size-56"
      [url]="data.badge.image"
      [alt]="data.badge.name"
      [showBorder]="true" />

    <h2
      data-test="badge-name"
      class="preset-title-1 text-center font-bold text-white uppercase">
      {{ data.badge.name }}
    </h2>

    <p
      data-test="badge-description"
      class="preset-body-2 text-center text-balance text-white">
      {{ data.badge.description }}
    </p>

    @if (data.badge.tiroLibre) {
    <button
      data-test="tiro-libre-button"
      class="preset-title-6 md:preset-title-4 shadow-button-inset text-primary-900 bg-accent-900 w-full cursor-pointer rounded-3xl px-3 py-1"
      (click)="goToTiroLibre()">
      Ir al tiro libre
    </button>
    }
  </section>
</div>
